var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-book-time",class:[_vm.isActive ? 'active' : '']},[_c('p',{staticClass:"widget-book-time-value"},[_vm._v(_vm._s(_vm.time.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }